<div *ngFor="let collection of collections">
  <div *ngFor="let input of collection">{{ input.name }} : {{ input.value }}</div>
  <hr />
</div>
